import * as React from 'react';
import { cn } from '@/lib/utils';
import { FormCheck } from '@/components/custom/form';

const FilterCheck = React.forwardRef(({ className, ...props }, ref) => (
  <FormCheck
    ref={ref}
    className={cn('c-filter-check', 'mb-3', className)}
    {...props}
  />
));
FilterCheck.displayName = 'FilterCheck';

export { FilterCheck };
